import type { StaticLayerPayload } from "@config";
import { FormLibrary } from "@library-elements/form";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: FormLibrary,
};

export const Form = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
